import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import EditProfileButton from '../EditProfileButton/EditProfileButton';
import { useNavigate } from 'react-router-dom';

export default function ProfileOptions() {
  const globalStyles = useGlobalStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>

      <IconButton onClick={handleClick}>
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >

          <IconButton className={globalStyles.popoverButtonContainer} onClick={() => navigate('/my-plan')}>
            <Box className={globalStyles.popoverIconContainer}>
              <CardMembershipIcon sx={{ color: colors.black, fontSize: 20 }} />
            </Box>
            <CustomText text="Current plan details" ml="5px" color={colors.black} />
          </IconButton>

          <EditProfileButton handleClose={handleClose} />

        </Box>
      </Popover>
    </div>
  );
}
